import styled from 'styled-components';
import { BlackButton } from '../../../baseComponents/button';
import { DialogOverlay as DO, DialogContent, DialogTitle } from '../../../baseComponents/dialog';
import { colours, fonts } from '../../../stylings';

export const DialogContentWrapper = styled(DialogContent)`
  max-width: 85vw;
`;

export const DialogOverlay = styled(DO)`
  background-color: ${colours.MODAL_BACKGROUND_WITH_OPACITY};
  inset: 0;
  position: fixed;
`;

export const DialogHeader = styled(DialogTitle)`
  ${fonts.Oswald}
  margin: 0;
  text-transform: uppercase;
`;

export const DialogButton = styled(BlackButton)`
  margin-bottom: 0;
  text-transform: uppercase;
  width: 100%;
`;
